
<script setup>

  import { ref, watch } from 'vue';

  const props = defineProps( {

    sequence: { type: Array, default: [] },

    frame: { type: Number, default: 0 } 
  
  } );

  const canvas = ref( null );

  const context = ref( null );

  const frames = ref( [] );

  function render() {

    if ( ! canvas.value || ! context.value ) return;

    const frame = frames.value[ props.frame ];

    context.value.clearRect( 0, 0, canvas.value.width, canvas.value.height );

    if ( frame?.complete ) context.value.drawImage(
      
      frame, 0, 0, canvas.value.width, canvas.value.height,
      
      0, 0, canvas.value.width, canvas.value.height
    
    );

  }

  watch( canvas, canvas => context.value = canvas?.getContext( '2d' ) || null );

  watch( () => props.frame, () => render() );

  watch( () => props.sequence, sequence => {
    
    frames.value = [];
    
    sequence.forEach( ( path, index ) => {

      const image = new Image();
      
      image.src = path;
      
      image.addEventListener( 'load', () => {
        
        frames.value[ index ] = image;
        
        if ( index === props.frame ) render();
      
      } );
    
    } );

  }, { immediate: true } );

</script>

<template>

  <canvas ref="canvas" />

</template>
